import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { Reason } from "../Export/AssetPandaExport";

export class ITGlueExport implements ObjectSerializer {
	public static readonly pdfName: string = 'PDF';
	public static readonly svgName: string = 'SVG';
	public static readonly vdxName: string = 'Visio (vdx)';
	public static readonly vsdxName: string = 'Visio (vsdx)';
	public static readonly mapFormatDropdownOptions: string[] = [this.vdxName, this.vsdxName, this.pdfName, this.svgName];

	public EnableExport: boolean;

	public TargetServerURL: string;
	public TargetServerApiURL: string;
	public TargetServerApiKey: string;
	public Organization: string;
	public Location: string;

	public ExportOrigin: string;

	public ExportDevices: boolean;
	public ExportDeviceInterfaces: boolean;
	public ExportConfigs: boolean;
	public ExportPasswords: boolean;

	public ExportMapToLocation: boolean;
	public MapFilename: string;
	public MapFileExtension: string;

	//public get StaticMapFormatDropdownOptions() {
	//	return this.mapFormatDropdownOptions;
	//}

	public get HasTargetServerURL(): boolean {
		return !!this.TargetServerURL;
	}

	public get HasTargetServerApiURL(): boolean {
		return !!this.TargetServerApiURL;
	}

	public get HasTargetServerApiKey(): boolean {
		return !!this.TargetServerApiKey;
	}

	public get HasOrganization(): boolean {
		return !!this.Organization;
	}

	public get HasLocation(): boolean {
		return !!this.Location;
	}

	public get HasExportOrigin(): boolean {
		return !!this.ExportOrigin;
	}

	public get HasMapFilename(): boolean {
		return !!this.MapFilename;
	}

	public get HasMapFileExtension(): boolean {
		return !!this.MapFileExtension;
	}

	constructor() {
		this.Clear();
	}

	public static TranslateMapFileExtension(fileFormatOption: string): string {
		switch (fileFormatOption) {
			case this.vdxName:
				return '.vdx';
			case this.vsdxName:
				return '.vsdx';
			case this.pdfName:
				return '.pdf';
			case this.svgName:
				return '.svg';
			default:
				return '';
		}
	}

	public Copy(other: ITGlueExport): void {
		this.Clear();

		this.EnableExport = other.EnableExport;

		this.TargetServerURL = other.TargetServerURL;
		this.TargetServerApiURL = other.TargetServerApiURL;
		this.TargetServerApiKey = other.TargetServerApiKey;
		this.Organization = other.Organization;
		this.Location = other.Location;

		this.ExportOrigin = other.ExportOrigin;

		this.ExportDevices = other.ExportDevices;
		this.ExportDeviceInterfaces = other.ExportDeviceInterfaces;
		this.ExportConfigs = other.ExportConfigs;
		this.ExportPasswords = other.ExportPasswords;

		this.ExportMapToLocation = other.ExportMapToLocation;
		this.MapFilename = other.MapFilename;
		this.MapFileExtension = other.MapFileExtension;
	}

	public Clear(): void {
		this.EnableExport = false;

		this.TargetServerURL = "";
		this.TargetServerApiURL = "";
		this.TargetServerApiKey = "";
		this.Organization = "";
		this.Location = "";

		this.ExportOrigin = "agent";

		this.ExportDevices = false;
		this.ExportDeviceInterfaces = false;
		this.ExportConfigs = false;
		this.ExportPasswords = false;

		this.ExportMapToLocation = false;
		this.MapFilename = "";
		this.MapFileExtension = "";
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof ITGlueExport))
			return false;
		var other = (obj as ITGlueExport);

		return (
			this.EnableExport == other.EnableExport &&

			this.TargetServerURL == other.TargetServerURL &&
			this.TargetServerApiURL == other.TargetServerApiURL &&
			this.TargetServerApiKey == other.TargetServerApiKey &&
			this.Organization == other.Organization &&
			this.Location == other.Location &&

			this.ExportOrigin == other.ExportOrigin &&

			this.ExportDevices == other.ExportDevices &&
			this.ExportDeviceInterfaces == other.ExportDeviceInterfaces &&
			this.ExportConfigs == other.ExportConfigs &&
			this.ExportPasswords == other.ExportPasswords &&

			this.ExportMapToLocation == other.ExportMapToLocation &&
			this.MapFilename == other.MapFilename &&
			this.MapFileExtension == other.MapFileExtension);
	}

	public IsValid(reason: Reason): boolean {
		reason.Value = "";

		if (this.EnableExport) {
			if (!this.HasTargetServerApiURL) {
				reason.Value = "The ITGlue API URL must be selected";
				return false;
			}
			if (!this.HasTargetServerApiKey) {
				reason.Value = "The ITGlue API key must be specified";
				return false;
			}
			if (!this.HasOrganization) {
				reason.Value = "A ITGlue organization name must be specified";
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	public Write(obj: any, context: any): void {
		obj.itglue_export = {};
		obj = obj.itglue_export;

		obj.enable_export = ValueEncoder.EncodeBoolean(this.EnableExport);

		if (this.HasTargetServerURL)
			obj.target_server_url = this.TargetServerURL;
		if (this.HasTargetServerApiURL)
			obj.target_server_api_url = this.TargetServerApiURL;
		if (this.HasTargetServerApiKey)
			obj.target_server_api_key = this.TargetServerApiKey;
		if (this.HasOrganization)
			obj.organization = this.Organization;
		if (this.HasLocation)
			obj.location = this.Location;

		if (this.HasExportOrigin)
			obj.export_origin = this.ExportOrigin;

		obj.export_devices = ValueEncoder.EncodeBoolean(this.ExportDevices);
		obj.export_device_interfaces = ValueEncoder.EncodeBoolean(this.ExportDeviceInterfaces);
		obj.export_configs = ValueEncoder.EncodeBoolean(this.ExportConfigs);
		obj.export_passwords = ValueEncoder.EncodeBoolean(this.ExportPasswords);

		obj.export_map_to_location = ValueEncoder.EncodeBoolean(this.ExportMapToLocation);
		if (this.HasMapFilename)
			obj.map_file_name = this.MapFilename;
		if (this.HasMapFileExtension)
			obj.map_file_ext = this.MapFileExtension;
	}

	public Read(obj: any, context: any): void {
		this.Clear();

		if (!obj.itglue_export)
			throw new Error();
		obj = obj.itglue_export;

		if (obj.enable_export !== undefined)
			this.EnableExport = ValueEncoder.DecodeBoolean(obj.enable_export);

		if (obj.target_server_url !== undefined)
			this.TargetServerURL = obj.target_server_url;
		if (obj.target_server_api_url !== undefined)
			this.TargetServerApiURL = obj.target_server_api_url;
		if (obj.target_server_api_key !== undefined)
			this.TargetServerApiKey = obj.target_server_api_key;
		if (obj.organization !== undefined)
			this.Organization = obj.organization;
		if (obj.location !== undefined)
			this.Location = obj.location;

		if (obj.export_origin !== undefined)
			this.ExportOrigin = obj.export_origin;

		if (obj.export_devices !== undefined)
			this.ExportDevices = ValueEncoder.DecodeBoolean(obj.export_devices);
		if (obj.export_device_interfaces !== undefined)
			this.ExportDeviceInterfaces = ValueEncoder.DecodeBoolean(obj.export_device_interfaces);
		if (obj.export_configs !== undefined)
			this.ExportConfigs = ValueEncoder.DecodeBoolean(obj.export_configs);
		if (obj.export_passwords !== undefined)
			this.ExportPasswords = ValueEncoder.DecodeBoolean(obj.export_passwords);

		if (obj.export_map_to_location !== undefined)
			this.ExportMapToLocation = ValueEncoder.DecodeBoolean(obj.export_map_to_location);
		if (obj.map_file_name !== undefined)
			this.MapFilename = obj.map_file_name;
		if (obj.map_file_ext !== undefined)
			this.MapFileExtension = obj.map_file_ext;
	}

}
